// extracted by mini-css-extract-plugin
module.exports = {"Card":"base_Card__RPCsO"};